import { useNavigate } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import { dashboardRoutes } from '../../routes/config/dashboard.routes';
import { AppLogo } from './AppLogo';
import ErrorFallback from './ErrorFallback';
import { SearchOutlined } from '@ant-design/icons';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <ErrorFallback
      details="The page you are looking for does not exist."
      message="Page not found"
      icon={<SearchOutlined />}
      error={new Error('Page not found')}
      resetErrorBoundary={() => navigate('/')}
    />
  );
};

export default PageNotFound;
